/* Brewie — Pour Ritual
   Extracted from POUR-RITUAL/previz/index.html, which stays the reference
   implementation. Behaviour is unchanged; the only edits are that the beat data
   now comes from section settings, every lookup is scoped to the section, and
   the end-of-story handoff resolves the following section rather than a
   hardcoded `.pz-shop`. */
document.body.classList.add('animated-landing-active');

// Shared easing helpers. These sat above the IIFEs in the previz; they are
// declared inside this file so the asset is self-contained.
const clamp = (v,a,b) => v<a?a:v>b?b:v;
const ease  = t => (t=clamp(t,0,1), t*t*(3-2*t));
const lerp  = (a,b,t) => a+(b-a)*t;

(function(){
  // Everything that was a literal in the previz now arrives from the section.
  const root = document.querySelector('[data-animated-landing]');
  if (!root) return;
  const cfg  = JSON.parse(root.querySelector('[data-animated-landing-config]').textContent);
  const BEATS  = cfg.beats;
  const KICKER = cfg.kicker || '';
  // `tags` arrives as a comma-split list from the section settings.
  BEATS.forEach(b => { b.tags = (b.tags || []).map(t => String(t).trim()).filter(Boolean); });

  // The story's end is the moment the NEXT section reaches the viewport bottom.
  // Prefer an explicit selector from the settings, fall back to whatever section
  // follows this one, so re-ordering in the customizer cannot break the handoff.
  const nextSection = (cfg.nextSelector && document.querySelector(cfg.nextSelector))
                   || (root.closest('.shopify-section') || root).nextElementSibling;

  // ---- theme chrome --------------------------------------------------------
  // The header, announcement bar and promo banner are three sibling sections
  // stacked at the top of the page. Translating each by its own height would
  // leave the lower ones showing, so they are measured in flow, then fixed at
  // stacked offsets and moved together by the group's FULL height.
  //
  // Fixing them also takes them out of the flow, which matters twice: the
  // sequence starts at the very top with no gap where they used to be, and
  // they stay pinned once revealed. This theme has sticky_header off, so a
  // revealed header left in flow would sit at the document top and never be
  // seen again.
  const chromeCfg = cfg.chrome || {};
  const chromeEls = (chromeCfg.pin || [])
    .map(sel => document.querySelector(sel))
    .filter(Boolean)
    .map(el => el.closest('.shopify-section') || el);

  (chromeCfg.hide || []).forEach(sel => {
    const el = document.querySelector(sel);
    if (el) (el.closest('.shopify-section') || el).classList.add('animated-landing-hidden');
  });

  function pinChrome(){
    if (!chromeEls.length) return;
    // Measuring means taking the class off, and reading offsetHeight flushes
    // style with it off - so the chrome's computed transform really does become
    // `none` for that moment. Putting the class back then transitions from
    // there, which is the header sliding down and easing back up. Suppressing
    // the transition around the whole measure-and-repin is what stops it.
    chromeEls.forEach(el => el.classList.add('animated-landing-repin'));
    // Measure in flow: the class is what fixes them, so it comes off first.
    chromeEls.forEach(el => el.classList.remove('animated-landing-chrome'));
    const heights = chromeEls.map(el => el.offsetHeight);
    let top = 0;
    chromeEls.forEach((el, i) => {
      el.style.setProperty('--al-chrome-top', top + 'px');
      top += heights[i];
      el.classList.add('animated-landing-chrome');
    });
    document.documentElement.style.setProperty('--al-chrome-h', top + 'px');
    // Flush the parked transform while transitions are still off, so releasing
    // them has nothing left to animate from.
    void document.documentElement.offsetWidth;
    chromeEls.forEach(el => el.classList.remove('animated-landing-repin'));
  }
  pinChrome();
  // One frame after the chrome is parked off-screen, allow it to animate. See
  // the .animated-landing-booted rule - without this the initial pin animates
  // from on-screen and reads as the header sliding away on page load.
  const markBooted = () => document.body.classList.add('animated-landing-booted');
  // rAF is the correct signal - a frame has been painted with the chrome parked.
  // It does not run at all in a background tab though, and the class gates the
  // transition, so a timer backs it up: worst case the reveal is instant rather
  // than never animated.
  requestAnimationFrame(() => requestAnimationFrame(markBooted));
  setTimeout(markBooted, 120);
  // Only a width change can alter how tall the chrome stacks. On a phone every
  // scroll direction change resizes the viewport HEIGHT as the browser's own
  // toolbar shows and hides, and re-pinning on those was the other half of the
  // flicker - a repin per scroll-up.
  let lastChromeW = innerWidth;
  addEventListener('resize', () => {
    // The released anchor was derived from the old viewport height, so it is
    // stale the moment that changes. Dropping it lets the next frame work the
    // release point out again.
    if (lastReleased){
      lastPin.classList.remove('pz-pin--released');
      lastPin.style.top = '';
      lastReleased = false;
    }
    if (innerWidth === lastChromeW) return;
    lastChromeW = innerWidth;
    pinChrome();
  }, {passive:true});

  const feather  = root.querySelector('[data-pz-feather]');
  const track    = root.querySelector('[data-pz-track]');
  const stage    = root.querySelector('[data-pz-stage]');
  const frames   = [...root.querySelectorAll('[data-pz-frame]')];
  const bar      = root.querySelector('[data-pz-bar]');
  const nav        = root.querySelector('[data-pz-nav]');
  const dotNav     = root.querySelector('[data-pz-dots]');
  const cart       = root.querySelector('[data-pz-cart]');
  const shopNow    = root.querySelector('[data-pz-shopnow]');
  const introCta   = root.querySelector('[data-pz-introcta]');
  const chapWrap = root.querySelector('[data-pz-chapters]');
  const frameIn  = frames.map(f => parseInt(f.dataset.in, 10));

  // ---- Mix -> Serve scrub --------------------------------------------------
  // The clip is all-keyframe, so setting currentTime lands on an exact frame
  // with no decode lag. Source is picked by viewport: no point pushing the
  // 1536 file at a phone.
  const small = matchMedia('(max-width: 700px)').matches;
  const vids = [...root.querySelectorAll('[data-pz-video]')].map(el => {
    const v = { el, from: parseInt(el.dataset.from, 10),
                    to:   parseInt(el.dataset.to,   10),
                cutFade: el.dataset.fade === 'cut',
                zoom: parseFloat(el.dataset.zoom) || 0,
                ready:false, target:0, seeking:false };
    el.src = small ? el.dataset.srcSm : el.dataset.src;
    // Same decision, same statement - the poster always matches the clip that
    // is actually loading. Only touched when a poster exists, so a beat without
    // one is left alone rather than getting poster="undefined".
    const poster = small ? el.dataset.posterSm : el.dataset.poster;
    if (poster) el.poster = poster;
    el.addEventListener('loadedmetadata', () => { v.ready = true; seekVid(v); }, {once:true});
    el.addEventListener('seeked', () => { v.seeking = false; seekVid(v); });
    return v;
  });

  // Where one clip ends on the same beat the next one starts, the two share a
  // frame: the last of the first IS the first of the second. That joint needs
  // no dissolve, and the earlier clip must stop scrubbing exactly where the
  // later one picks up rather than running on underneath it.
  vids.forEach((v, i) => {
    const prev = vids[i - 1], next = vids[i + 1];
    v.cutIn     = v.cutFade || !!(prev && prev.to === v.from);
    v.joinsNext = !!(next && next.from === v.to);
  });

  // iOS will not seek a video that has never been allowed to play. A muted
  // play/pause on first touch unlocks it without anything being audible.
  const unlock = () => vids.forEach(v => {
    const r = v.el.play();
    if (r && r.then) r.then(() => v.el.pause()).catch(()=>{});
  });
  addEventListener('touchstart', unlock, {once:true, passive:true});
  addEventListener('click', unlock, {once:true});

  function seekVid(v){
    if (!v.ready || v.seeking) return;
    const d = v.el.duration;
    if (!d || !isFinite(d)) return;
    const t = clamp(v.target, 0, 1) * d;
    // A tolerance stops us queueing a seek for sub-frame movement, which is
    // what makes scrubbed video stutter.
    if (Math.abs(v.el.currentTime - t) < (1 / 48)) return;
    v.seeking = true;
    v.el.currentTime = t;
  }

  // The cue is a column: an optional label plus the icon. Label always comes
  // first in the DOM so it is announced before the icon; whether it renders
  // above or below is column vs column-reverse in the CSS.
  function cueHTML(){
    const label = cfg.cueLabel || 'Scroll down';
    // An uploaded cue replaces the chevrons rather than sitting beside them, so
    // the animation is whatever the image itself does. A separate mobile image
    // is rendered alongside and swapped by media query - no resize listener,
    // and no wrong image on a device that starts rotated.
    const icon = cfg.cueImage
      ? `<span class="pz-scroll__icon"><img class="pz-scroll__img pz-scroll__img--lg" src="${cfg.cueImage}" alt="">${
           cfg.cueImageSm ? `<img class="pz-scroll__img pz-scroll__img--sm" src="${cfg.cueImageSm}" alt="">` : ''}</span>`
      : `<span class="pz-scroll__icon"><i aria-hidden="true"></i><i aria-hidden="true"></i></span>`;
    const text = cfg.cueText ? `<span class="pz-scroll__text">${cfg.cueText}</span>` : '';
    const cls = ['pz-scroll'];
    if (cfg.cueImage)   cls.push('pz-scroll--custom');
    if (cfg.cueImageSm) cls.push('pz-scroll--dual');
    cls.push(cfg.cueTextPos === 'above' ? 'pz-scroll--text-above' : 'pz-scroll--text-below');
    return `<button class="${cls.join(' ')}" data-pz-cue type="button" aria-label="${label}">${text}${icon}</button>`;
  }

  // ---- build chapters + nav ------------------------------------------------
  const links = [];
  const dots  = [];
  BEATS.forEach((b,i) => {
    const sec = document.createElement('section');
    sec.className = 'pz-chapter';
    sec.dataset.beat = i;
    // Speed is a percentage of the normal pace. The CSS divides the chapter's
    // height by it, so 150 means this beat occupies two thirds of the scroll it
    // used to and its clip scrubs through in that shorter distance.
    if (b.speed && b.speed !== 100) sec.style.setProperty('--beat-speed', (b.speed / 100).toFixed(3));
    // The mobile speed is a second property rather than a re-write of the first:
    // an inline style cannot be put behind a media query, so both values are set
    // here and the stylesheet picks which divisor the chapter height uses.
    if (b.speedSm) sec.style.setProperty('--beat-speed-sm', (b.speedSm / 100).toFixed(3));
    // Placement. A blank setting means "as before": Copy side across, beat 01
    // centred at the top and every other beat vertically centred; mobile falls
    // back to the desktop value. Both pairs of classes are always emitted and
    // the media query decides which applies, so a rotation needs no listener.
    const px = b.px || (i === 0 ? 'center' : (b.side || 'left'));
    const py = b.py || (i === 0 ? 'top' : 'middle');
    const pinCls = ['pz-pin'];
    if (i === 0) pinCls.push('pz-pin--first');
    pinCls.push('pz-pin--x-' + px, 'pz-pin--y-' + py);
    // The mobile classes are emitted ONLY when the beat names a mobile
    // position. Left unset, the phone keeps the layout it has always had -
    // side beats stack to the left edge - which a class mirroring the desktop
    // value would have overridden.
    if (b.pxSm) pinCls.push('pz-pin--sm-x-' + b.pxSm);
    if (b.pySm) pinCls.push('pz-pin--sm-y-' + b.pySm);

    // Per-beat custom properties: the nudges, and the panel and gradient when
    // either is switched on at either breakpoint. Emitted only where set, so a
    // beat that uses none of this carries no inline style at all.
    const vars = [];
    if (b.nx)   vars.push('--al-nudge-x:'    + b.nx   + 'px');
    if (b.ny)   vars.push('--al-nudge-y:'    + b.ny   + 'px');
    if (b.nxSm) vars.push('--al-nudge-x-sm:' + b.nxSm + 'px');
    if (b.nySm) vars.push('--al-nudge-y-sm:' + b.nySm + 'px');
    if (b.panel) vars.push('--al-panel-rgb:' + b.panel.rgb,
                           '--al-panel-a:'   + b.panel.a,
                           '--al-panel-pad:' + b.panel.pad + 'px',
                           '--al-panel-pad-sm:' + b.panel.padSm + 'px',
                           '--al-panel-r:'   + b.panel.r + 'px');
    if (b.grad)  vars.push('--al-grad-rgb:'  + b.grad.rgb,
                           '--al-grad-a:'    + b.grad.a,
                           '--al-grad-a-sm:' + b.grad.aSm,
                           '--al-grad-h:'    + b.grad.h + '%',
                           '--al-grad-h-sm:' + b.grad.hSm + '%');

    const copyCls = ['pz-copy'];
    if (b.panel && b.panel.on)   copyCls.push('pz-copy--panel-lg');
    if (b.panel && b.panel.onSm) copyCls.push('pz-copy--panel-sm');

    // The gradient is a sibling before the copy, so the copy paints over it
    // without either needing a z-index.
    const gradCls = ['pz-beatgrad'];
    if (b.grad && !b.grad.on)   gradCls.push('pz-beatgrad--lg-off');
    if (b.grad && !b.grad.onSm) gradCls.push('pz-beatgrad--sm-off');
    const grad = b.grad ? `<div class="${gradCls.join(' ')}" aria-hidden="true"></div>` : '';

    sec.innerHTML =
      `<div class="${pinCls.join(' ')}"${vars.length ? ` style="${vars.join(';')}"` : ''}>${grad}<div class="${copyCls.join(' ')}"${
         // Per-beat width overrides. Emitted only when set, so a beat left at 0
         // inherits the section's value, which in turn falls back to the design.
         (b.w || b.wSm || b.bw)
           ? ` style="${b.w   ? '--al-copy-w:'   + b.w   + 'px;' : ''}${
                        b.wSm ? '--al-copy-w-sm:' + b.wSm + 'px;' : ''}${
                        b.bw  ? '--al-body-w:'    + b.bw  + 'px;' : ''}"`
           : ''}>
         ${b.kicker === '' ? '' : `<p class="pz-kicker">${b.kicker || KICKER}</p>`}
         <h2 class="pz-title">${b.title || b.label}</h2>
         <p class="pz-body">${b.body}</p>
         ${(b.tags.length || b.cta) ? `<ul class="pz-tags">${
             b.cta ? `<li class="pz-cta"><a href="${b.cta.target}" data-pz-cta>${b.cta.label}</a></li>` : ''
           }${b.tags.map(t=>`<li>${t}</li>`).join('')}</ul>` : ''}
       ${i === 0 && cfg.cue !== false ? cueHTML() : ''}
       </div></div>`;
    chapWrap.appendChild(sec);

    // Shared by the text nav and the dot nav, so the two can never disagree
    // about where a beat starts.
    const goTo = () => {
      // The last beat's chapter top is nowhere near the end of the story - the
      // sequence runs on for most of a chapter past it. Land 1px short of where
      // the progress bar completes instead, so the bar reads full, the last beat
      // is still up, and the header has not taken over yet.
      if (i === BEATS.length - 1){
        const first = chapters[0].getBoundingClientRect().top + window.scrollY;
        const total = Math.max(1, track.offsetHeight - stage.offsetHeight - SHOP_LAP);
        window.scrollTo({ top: Math.round(first + total) - 1, behavior:'smooth' });
        return;
      }
      const r = chapters[i].getBoundingClientRect();
      window.scrollTo({ top: Math.round(window.scrollY + r.top), behavior:'smooth' });
    };

    const a = document.createElement('a');
    a.href = '#';
    a.innerHTML = `<span class="n">${b.n}</span><span>${b.label}</span>`;
    a.title = `${b.n} — ${b.label}`;
    a.addEventListener('click', ev => { ev.preventDefault(); goTo(); });
    nav.appendChild(a); links.push(a);

    if (dotNav){
      const d = document.createElement('button');
      d.type = 'button';
      d.title = `${b.n} — ${b.label}`;
      // The text nav already names every beat, so the dots are a duplicate for
      // a screen reader. Labelled but hidden from the list.
      d.setAttribute('aria-label', `${b.n} — ${b.label}`);
      d.addEventListener('click', goTo);
      dotNav.appendChild(d); dots.push(d);
    }
  });
  const chapters = [...chapWrap.children];
  const copies = chapters.map(c => c.querySelector('.pz-copy'));
  // Null for every beat without a gradient, so the indexes line up with copies.
  const grads  = chapters.map(c => c.querySelector('.pz-beatgrad'));
  // The final beat is the one that rides out with the page; it is released from
  // its fixed slot into its chapter at the hand-off. See the release in render().
  const lastChapter = chapters[chapters.length - 1];
  const lastPin     = lastChapter.querySelector('.pz-pin');
  let lastReleased  = false;
  // The shop is pulled up over the track by this much, so the track's final
  // SHOP_LAP pixels are the section already arriving rather than story left.
  const SHOP_LAP = parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue('--shop-lap')) || 0;
  // How much scroll a beat's copy takes to cross over to the next one.
  const FADE_VH = 0.20;
  // Share of beat 01's chapter its copy takes to fade out. It is the only beat
  // that fades on its own schedule rather than against the next one arriving.
  const BEAT1_FADE = 0.5;
  // How much earlier a beat clears than the next one arrives, as a share of its
  // own chapter. The two curves used to be the same value, so a beat was still
  // solid until the moment its successor started rising; this runs the exit
  // ahead so the copy is gone before the next arrives.
  const LEAVE_LEAD = 0.20;

  // The cue lands on the frame beat 02's copy is fully in - its chapter top at
  // 0, which is where `arrive` reaches 1. Same anchor the beat 02 nav link uses,
  // so the two agree.
  const cue = chapWrap.querySelector('[data-pz-cue]');
  if (cue) cue.addEventListener('click', () => {
    const r = chapters[1] && chapters[1].getBoundingClientRect();
    if (r) window.scrollTo({ top: Math.round(window.scrollY + r.top), behavior:'smooth' });
  });

  if (shopNow) shopNow.addEventListener('click', () => {
    const t = cfg.shopNowSelector ? document.querySelector(cfg.shopNowSelector) : nextSection;
    if (t) window.scrollTo({ top: Math.round(window.scrollY + t.getBoundingClientRect().top), behavior:'smooth' });
  });

  chapWrap.querySelectorAll('[data-pz-cta]').forEach(a => {
    a.addEventListener('click', ev => {
      ev.preventDefault();
      const t = document.querySelector(a.getAttribute('href'));
      if (t) window.scrollTo({ top: Math.round(window.scrollY + t.getBoundingClientRect().top), behavior:'smooth' });
    });
  });

  // ---- per-frame render ----------------------------------------------------
  let ticking = false, active = -1;

  function render(){
    const vh = stage.offsetHeight;

    // how far each chapter's copy has travelled into place: 0 when its top sits
    // at the viewport bottom, 1 once it has reached the top and pinned
    const enter = chapters.map(c => ease(clamp((vh - c.getBoundingClientRect().top) / vh, 0, 1)));
    for (let i = 0; i < frames.length; i++){
      const b = frameIn[i];
      frames[i].style.opacity = (b === 0 ? 1 : enter[b]).toFixed(3);
    }

    // A clip scrubs from the top of its "from" beat. A joined clip stops at the
    // top of its "to" beat, which is the exact scroll position the next clip
    // reads as its own frame 0; an unjoined one runs to the end of that beat's
    // pin and holds. Opacity follows the same split: a joined clip cuts in on
    // the shared frame, an unjoined one dissolves over whatever precedes it.
    for (const v of vids){
      if (!chapters[v.from] || !chapters[v.to]) continue;
      const startTop = chapters[v.from].getBoundingClientRect().top + window.scrollY;
      const endEl    = chapters[v.to];
      const endTop   = endEl.getBoundingClientRect().top + window.scrollY
                     + (v.joinsNext ? 0 : Math.max(0, endEl.offsetHeight - vh));
      v.target = clamp((window.scrollY - startTop) / Math.max(1, endTop - startTop), 0, 1);
      seekVid(v);
      v.opacity = v.cutIn ? (window.scrollY >= startTop ? 1 : 0) : enter[v.from];
      v.el.style.opacity = v.opacity.toFixed(3);
      // Optional push-in: the clip starts this much larger and settles to 1
      // across its own scrub, so the zoom tracks the footage rather than the
      // page - it lands exactly as the clip reaches its last frame.
      if (v.zoom) v.el.style.transform = `scale(${(1 + v.zoom * (1 - v.target)).toFixed(4)})`;
    }

    // Dropping SHOP_LAP from the span makes "bar full" and "story over" the
    // same instant: the bar completes exactly as the shop reaches the viewport
    // bottom, which is the first frame anything moves. Before, the bar still had
    // that lap to run while the section was already sliding up behind it.
    const first = chapters[0].getBoundingClientRect().top + window.scrollY;
    const total = Math.max(1, track.offsetHeight - vh - SHOP_LAP);
    const progress = clamp((window.scrollY - first) / total, 0, 1);
    bar.style.transform = `scaleX(${progress.toFixed(4)})`;

    // Feather: 0 means show it for the whole sequence, otherwise ramp it in
    // across the remaining share of the progress bar.
    if (feather){
      const fs = cfg.featherStart || 0;
      feather.style.opacity = (fs <= 0 ? 1
        : ease(clamp((progress - fs) / (1 - fs), 0, 1))).toFixed(3);
    }

    // Measured once: the shop's edge drives the animated-landing-done handoff, the final
    // beat's fade, and the final beat's travel.
    const shopEl  = nextSection;
    const shopTop = shopEl ? shopEl.getBoundingClientRect().top : Infinity;

    // The story is over when the bar is, not a fraction of a viewport earlier.
    // Tying the handoff to the same number keeps the header, the pin release and
    // the bar's own exit on one frame instead of three near-misses.
    const done = progress >= 1;
    document.body.classList.toggle('animated-landing-done', done);

    // Copy crossfade. Every beat's block sits in the same fixed slot, so the
    // handoff is opacity alone. `arrive` is how far a chapter has come toward
    // its own start; a beat is visible once it has arrived and hides again by
    // exactly the amount the NEXT beat has arrived, so the pair always sums to
    // one and there is never a gap or a double exposure between them.
    const fadeLead = vh * FADE_VH;
    // A beat's optional `lead` runs both its curves earlier, as a share of its
    // own chapter, without changing how long either takes.
    const leadOf = i => (BEATS[i] && BEATS[i].lead) || 0;
    const arrive = chapters.map((c, i) =>
      ease(clamp((fadeLead + c.offsetHeight * leadOf(i)
                  - c.getBoundingClientRect().top) / fadeLead, 0, 1)));
    // Same duration as `arrive`, started earlier: the window opens LEAVE_LEAD of
    // a chapter further out and still takes fadeLead to complete.
    const leave = chapters.map((c, i) => {
      const nx = chapters[i + 1];
      // The last beat has no exit fade: it leaves by travelling with the page.
      if (!nx) return 0;
      const start = fadeLead + c.offsetHeight * (LEAVE_LEAD + leadOf(i));
      return ease(clamp((start - nx.getBoundingClientRect().top) / fadeLead, 0, 1));
    });
    // Beat 01 is on screen from the first paint, so it has no arrival to play.
    // Rather than sitting at full opacity and then dropping in the last stretch
    // like the others, it fades across its whole chapter: solid at the top of
    // the page, gone by the time beat 02 arrives.
    const c0 = chapters[0].getBoundingClientRect();
    const leave0 = ease(clamp(-c0.top / Math.max(1, c0.height * BEAT1_FADE), 0, 1));

    let op0 = 1;
    for (let i = 0; i < copies.length; i++){
      const op = i === 0 ? (1 - leave0) * (1 - (arrive[1] || 0))
                         : arrive[i] * (1 - leave[i]);
      if (i === 0) op0 = op;
      copies[i].style.opacity = op.toFixed(3);
      // Same curve as the copy: the gradient belongs to this beat, so it has to
      // arrive and clear with it rather than sitting under the next one.
      if (grads[i]) grads[i].style.opacity = op.toFixed(3);
      // The blocks overlap in the same slot, so a faded-out beat would still
      // swallow clicks meant for the visible one.
      copies[i].style.pointerEvents = op > 0.5 ? 'auto' : 'none';
    }

    // The beat nav is page chrome, not part of the opening frame: it fades up on
    // exactly the inverse of beat 01's copy, so the two never share the screen at
    // full strength and the handoff needs no timing of its own.
    if (nav){
      const navOp = 1 - op0;
      nav.style.opacity = navOp.toFixed(3);
      // A faded nav still sits over the frame at full size, so without this its
      // links stay clickable while invisible.
      nav.style.pointerEvents = navOp > 0.5 ? 'auto' : 'none';
      if (dotNav){
        dotNav.style.opacity = navOp.toFixed(3);
        dotNav.style.pointerEvents = navOp > 0.5 ? 'auto' : 'none';
      }
    }

    // Straight inverse of the nav, so the two swap in place.
    if (introCta){
      introCta.style.opacity = op0.toFixed(3);
      introCta.style.pointerEvents = op0 > 0.5 ? 'auto' : 'none';
    }

    // The cart arrives with the nav and leaves as the shop does: in on beat 01's
    // inverse, out over the same distance every other exit uses, starting the
    // frame the shop touches the viewport bottom. Driving it from scroll rather
    // than a class keeps both ends smooth and reversible.
    if (cart){
      const cartOp = (1 - op0) * (1 - ease(clamp((vh - shopTop) / fadeLead, 0, 1)));
      cart.style.opacity = cartOp.toFixed(3);
      cart.style.pointerEvents = cartOp > 0.5 ? 'auto' : 'none';
    }

    // The last beat leaves by scrolling, not fading, and at exactly page speed.
    // Keyed to the shop's top edge rather than the last chapter's bottom: the
    // shop is pulled up over the track by --shop-lap, so it enters the viewport
    // that far before the chapter ends.
    //
    // It travels by being released into the document rather than by a transform
    // written per frame. A fixed element moved from a scroll handler is always a
    // frame behind the page, which the compositor scrolls on its own thread -
    // that lag is what read as a floaty, slightly-off scroll speed against the
    // sections below. Once released the browser scrolls it with everything
    // else, so the speeds cannot drift apart at all.
    if (shopEl && shopTop <= vh){
      if (!lastReleased){
        // Anchored to the scroll position where the shop's edge MEETS the
        // viewport bottom, not to wherever the pin happens to stand on the
        // frame that noticed. A fast flick can cross that point by hundreds of
        // pixels in one frame, and anchoring to the frame would leave the copy
        // that far down the screen for the rest of the ride.
        const shopDocTop = window.scrollY + shopTop;
        const releaseY   = shopDocTop - vh;
        const chapDocTop = window.scrollY + lastChapter.getBoundingClientRect().top;
        lastPin.style.top = (releaseY - chapDocTop) + 'px';
        lastPin.classList.add('pz-pin--released');
        lastReleased = true;
      }
    } else if (lastReleased){
      lastPin.classList.remove('pz-pin--released');
      lastPin.style.top = '';
      lastReleased = false;
    }

    let beat = 0;
    for (let i = 0; i < chapters.length; i++) if (enter[i] > 0.5) beat = i;
    if (beat !== active){
      active = beat;
      links.forEach((a,i) => a.classList.toggle('is-active', i === beat));
      dots.forEach((d,i) => d.classList.toggle('is-active', i === beat));
    }
  }

  function onScroll(){ if (!ticking){ ticking = true; requestAnimationFrame(()=>{ ticking=false; render(); }); } }
  addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', onScroll, {passive:true});

  render();                       // paint now; rAF is throttled in a background tab
  window.__pzReady = true;
  window.__pz = { render, frames, chapters, BEATS };
})();

(function(){
  const root = document.querySelector('[data-animated-landing]');
  const btn  = root && root.querySelector('[data-pz-cart]');
  const cfg  = root && JSON.parse(root.querySelector('[data-animated-landing-config]').textContent);
  const card = cfg && cfg.formSelector ? document.querySelector(cfg.formSelector) : null;
  if (!btn || !card) return;
  btn.addEventListener('click', () => {
    const r = card.getBoundingClientRect();
    // Centre the card rather than aligning its top: it is the thing being
    // pointed at, and a top-aligned jump leaves it tucked under the header.
    // If it is ever taller than the viewport the max() falls back to its top.
    const top = r.top + window.scrollY - Math.max(0, (innerHeight - r.height) / 2);
    window.scrollTo({ top: Math.round(top), behavior:'smooth' });
  });
})();
